"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ModularTable.default;
  }
});

var _ModularTable = _interopRequireDefault(require("./ModularTable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }